import { AgGridAngular, ICellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, GridOptions, ICellRendererParams } from 'ag-grid-community';
import { Component, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { buildGridOptions } from '@gestor-web/app/shared/components';
import { FornecimentoDiretoDetalheItem, FornecimentoDiretoDetalheItemMotivoRejeicao } from '@gestor-web/@core/api/ords/model';

const COLUMNS_MOTIVOS_REJEICAO: ColDef[] = [
  {
    headerName: 'Campo',
    field: 'campo',
    width: 300,
  },
  {
    headerName: 'Motivos de rejeição',
    field: 'motivo_rejeicao',
    width: 500,
    wrapText: true,
    autoHeight: true,
  },
];

@Component({
    selector: 'bl-fornecimento-item-detalhe-cell',
    templateUrl: './item-detalhe-cell.component.html',
    styleUrls: ['./item-detalhe-cell.component.scss'],
    standalone: false
})
export class ItemDetalheCellRenderer implements ICellRendererAngularComp {
  @ViewChild('agGridMotivosRejeicao') agGridMotivosRejeicao: AgGridAngular<FornecimentoDiretoDetalheItemMotivoRejeicao>;

  gridOptionsMotivosRejeicao: GridOptions<FornecimentoDiretoDetalheItemMotivoRejeicao>;

  params: ICellRendererParams<FornecimentoDiretoDetalheItem>;
  data: FornecimentoDiretoDetalheItem;


  agInit(params: ICellRendererParams<FornecimentoDiretoDetalheItem>): void {
    this.configureGrids();

    this.updateValue(params);
  }

  refresh(params: ICellRendererParams<FornecimentoDiretoDetalheItem>) {
    this.updateValue(params);
    return true;
  }

  updateValue(params: ICellRendererParams<FornecimentoDiretoDetalheItem>) {
    this.params = params;
    this.data = params.data;
  }

  configureGrids() {
    this.gridOptionsMotivosRejeicao = buildGridOptions<FornecimentoDiretoDetalheItemMotivoRejeicao>(
      {
        columnDefs: COLUMNS_MOTIVOS_REJEICAO,
      },
      {
        sideBar: null,
        statusBar: null,
        grandTotalRow: null,
      },
    );
  }

  private ngDestroyed$ = new Subject<void>();
  ngOnDestroy() {
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  }
}
